import { Button } from "@/components/ui/button";
import { ArrowRightLeft, Plus, Paperclip } from "lucide-react";

const TABS = [
  { key: "active", label: "All" },
  { key: "needs_review", label: "Needs Review" },
  { key: "waiting", label: "Waiting on Employee" },
  { key: "drafts", label: "Drafts" },
  { key: "approved", label: "Approved" },
  { key: "rejected", label: "Rejected" },
];

export const ARCHIVE_TABS = [
  { key: "exported", label: "Exported", countKey: "exported" },
  { key: "not_exported", label: "Not exported", countKey: "archived" },
];

const tabClass = (active) =>
  `flex items-center gap-1.5 whitespace-nowrap rounded-xl px-3 py-1.5 text-[12.5px] transition-colors ${
    active ? "bg-[#1f1f1f] text-white" : "text-[#A3A3A3] hover:text-white"}`;

const CountBadge = ({ children }) => (
  <span className="rounded-md bg-[#1f1f1f] px-1.5 text-[10px] tabular-nums text-[#6b6b6b]">{children}</span>
);

export const ExpensesHeader = ({
  mode, setMode, tab, setTab, view, setView, tabCounts,
  archiveTab, setArchiveTab, archiveCounts,
  onDataMovement, onAddReceipt, onCreate,
}) => (
  <div className="flex items-center gap-2">
    {/* Active / Archive mode switch */}
    <div className="flex h-8 shrink-0 items-center rounded-xl border border-[#222] bg-[#111] p-0.5" data-testid="expenses-mode-switch">
      {[{ key: "active", label: "Active" }, { key: "archive", label: "Archive" }].map((m) => (
        <button key={m.key} onClick={() => setMode(m.key)} data-testid={`expenses-mode-${m.key}`}
          className={`flex h-[26px] items-center rounded-[8px] px-3 text-[12px] transition-colors ${
            mode === m.key ? "bg-[#1f1f1f] text-white" : "text-[#A3A3A3] hover:text-white"}`}>
          {m.label}
        </button>
      ))}
    </div>

    {/* status tabs (scrollable strip) */}
    <div className="scrollbar-none flex min-w-0 flex-1 items-center gap-1 overflow-x-auto">
      {mode === "archive"
        ? ARCHIVE_TABS.map((t) => (
          <button key={t.key} onClick={() => setArchiveTab(t.key)} data-testid={`archive-tab-${t.key}`}
            className={tabClass(archiveTab === t.key)}>
            {t.label} <CountBadge>{archiveCounts?.[t.countKey] ?? 0}</CountBadge>
          </button>
        ))
        : TABS.map((t) => (
          <button key={t.key} onClick={() => setTab(t.key)} data-testid={`expenses-tab-${t.key}`}
            className={tabClass(tab === t.key && view === "table")}>
            {t.label} <CountBadge>{tabCounts?.[t.key] ?? 0}</CountBadge>
          </button>
        ))}
    </div>

    {/* pinned actions */}
    {mode === "active" && (
      <div className="ml-auto flex shrink-0 items-center gap-2">
        {tab === "approved" && view === "table" && (
          <Button variant="outline" onClick={onDataMovement} data-testid="data-movement-button"
            className="h-8 shrink-0 whitespace-nowrap border-0 bg-[rgba(79,142,247,0.12)] px-3 text-[12px] text-[#7FAEF9] hover:bg-[rgba(79,142,247,0.24)] hover:text-white">
            <ArrowRightLeft size={12} className="mr-1.5" /> Data Movement
          </Button>
        )}
        <Button variant="outline" onClick={onAddReceipt} data-testid="add-receipt-button"
          className="h-8 whitespace-nowrap border-[#2a2a2a] bg-transparent px-3 text-[12.5px] text-[#A3A3A3] hover:bg-[#1c1c1c] hover:text-white">
          <Paperclip size={13} className="mr-1.5" /> Add Receipt
        </Button>
        <Button onClick={onCreate} data-testid="create-expense-button"
          className="h-8 btn-gradient whitespace-nowrap px-3.5 text-[12.5px] font-medium text-white">
          <Plus size={13} className="mr-1.5" /> Create Expense
        </Button>
      </div>
    )}
  </div>
);
